import Vue from 'vue';
import vClickOutside from 'v-click-outside';

export default {
    init() {
        Vue.use(vClickOutside);
    },
};

